const handleData = weekData => {
	let allWeeks = [
		'星期一',
		'星期二',
		'星期三',
		'星期四',
		'星期五',
		'星期六',
		'星期日',
	];

	// 补齐缺失的星期数据
	allWeeks = allWeeks.map((item, i) => {
		let newItem = {
			id: i,
			week: item,
			value: '',
		};
		weekData.some(subItem => {
			if (subItem.week === item) {
				newItem = { ...subItem };
				return true; // 找到匹配项后终止循环
			}
		});
		return newItem;
	});

	// 日期格式化函数
	const formatDate = (date, fmt) => {
		const o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'h+': date.getHours(),
			'm+': date.getMinutes(),
			's+': date.getSeconds(),
			'q+': Math.floor((date.getMonth() + 3) / 3),
			S: date.getMilliseconds(),
		};

		// 处理年份
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(
				RegExp.$1,
				(date.getFullYear() + '').substr(4 - RegExp.$1.length)
			);
		}

		// 处理其他部分
		for (const k in o) {
			if (new RegExp('(' + k + ')').test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					RegExp.$1.length === 1 ?
					o[k] :
					('00' + o[k]).substr(('' + o[k]).length)
				);
			}
		}
		return fmt;
	};

	// 创建数字数组
	const createArr = len => Array.from(Array(len)).map((_, id) => id);

	// 格式化时间段 (修复00:00问题)
	const formatWeektime = col => {
		const timestamp = 1542384000000; // 基准时间
		const beginstamp = timestamp + col * 1800000; // 30分钟间隔
		const endstamp = beginstamp + 1800000;

		const begin = formatDate(new Date(beginstamp), 'hh:mm');
		let end = formatDate(new Date(endstamp), 'hh:mm');

		// 关键修复：将00:00转换为24:00
		if (end === '00:00') {
			end = '24:00';
		}

		return `${begin}~${end}`;
	};

	// 构建完整数据结构
	const data = allWeeks.map((ret, index) => {
		const children = (ret, row, max) => {
			const valueRange = [];

			// 解析已选择的时间段 - 修复24:00处理
			if (ret.value) {
				ret.value.split('、').forEach(item => {
					if (item) {
						let [start, end] = item.split('~');
						valueRange.push({ start, end });
					}
				});
			}

			// 创建48个时间格子
			return createArr(max).map((_, col) => {
				const timeStr = formatWeektime(col);
				const [begin, end] = timeStr.split('~');

				const newItem = {
					week: ret.week,
					value: timeStr,
					begin,
					end,
					row,
					col,
					check: false
				};

				// 检查是否在选定范围内
				if (valueRange.length) {
					for (const range of valueRange) {
						// 特殊处理24:00的情况
						const rangeEnd = range.end === '24:00' ? '23:59' : range.end;
						const itemEnd = end === '24:00' ? '23:59' : end;

						// 比较时间（字符串比较）
						if (begin >= range.start && itemEnd <= rangeEnd) {
							newItem.check = true;
							break;
						}
					}
				}

				return newItem;
			});
		};

		return {
			value: ret.week,
			row: index,
			child: children(ret, index, 48),
		};
	});

	return data;
};

// 时间段拼接函数
const splicing = list => {
	if (!list?.length) return '';

	const result = [];
	let currentRange = null;

	list.forEach(item => {
		if (item.check) {
			if (!currentRange) {
				currentRange = { start: item.begin, end: item.end };
			} else if (item.begin === currentRange.end) {
				currentRange.end = item.end;
			} else {
				result.push(`${currentRange.start}~${currentRange.end}`);
				currentRange = { start: item.begin, end: item.end };
			}
		} else if (currentRange) {
			result.push(`${currentRange.start}~${currentRange.end}`);
			currentRange = null;
		}
	});

	// 处理最后一个时间段
	if (currentRange) {
		result.push(`${currentRange.start}~${currentRange.end}`);
	}

	return result.join('、');
};

export default handleData;
export { splicing };